import { Type } from 'class-transformer';
import * as moment from 'moment-timezone';
import { KeyValueResultDto } from '../../../../../_models/key-value-result-dto';
import { ARPaymentIssueRefundRawDto } from './ar-payment-issue-refund-raw-dto';

export class ARPaymentIssueRefundEditorResultDto {
    owner: string;
    maxRefundAmount: number;
    @Type(() => Date)
    closedBookPeriod: Date;
    @Type(() => ARPaymentIssueRefundRawDto)
    issueRefundInfo: ARPaymentIssueRefundRawDto;
    @Type(() => KeyValueResultDto)
    subLedgers: KeyValueResultDto[];

    get minPostDate(): Date {
        return !!this.closedBookPeriod ? moment(this.closedBookPeriod).add(1, 'day').toDate() : null;
    }
}
